const toInt = (input: string | undefined) => typeof input === 'string' ? parseInt(input) : input;

window.env = {
    API_SERVER: process.env.REACT_APP_API_SERVER,
    DATADOG_APP_ID: process.env.REACT_APP_DATADOG_APP_ID,
    DATADOG_BUILD_VERSION: process.env.REACT_APP_DATADOG_BUILD_VERSION,
    DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    DATADOG_SERVICE: process.env.REACT_APP_DATADOG_SERVICE,
    DATADOG_ENV: process.env.REACT_APP_DATADOG_ENV,
    DATADOG_SESSION_SAMPLE_RATE: toInt(process.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE),
    DATADOG_SESSION_REPLAY_SAMPLE_RATE: toInt(process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE)
  } as const;
  
  // Do not export from here, otherwise this file will get bundled with the app
  export {};